/*global chrome*/
import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";

class FameWallPte extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      homePage: false,
    };
  } 
  render() {
    const pteSlider = {
      dots: true,
      arrows: true,
      // infinite: true,
      speed: 500,
      slidesToShow: 6,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 5,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    };
    return (
      <div className="our-champions-heading fm-commendable-heading">
        <div className="container">
          <div className="row">
            <h2 className="primary-heading text-center">
            Score Cards <br /> of our <span className="pte-naati-badge">PTE students</span>
            </h2>
            <p className="sub-heading text-center">
              A candidate’s score on the scorecard of the PTE exam speaks the success rate <br className="d-none d-xl-block" /> of the LA-Language Academy Jalandhar PTE centre. Not once, but several times.
            </p>
          </div>  
        </div>
        <div className="our-champions-pte">
          <div className="pte-slider">
            <Slider {...pteSlider}>
                <div className="img-wrapper">
                  <img src="/images/web-new-images/pte/pte1.jpeg" alt="LA" />
                </div>
                <div className="img-wrapper">
                  <img src="/images/web-new-images/pte/pte2.jpeg" alt="LA" />
                </div>
                <div className="img-wrapper">
                  <img src="/images/web-new-images/pte/pte3.jpeg" alt="LA" />
                </div>
                <div className="img-wrapper">
                  <img src="/images/web-new-images/pte/pte4.jpeg" alt="LA" />
                </div>
                <div className="img-wrapper">
                  <img src="/images/web-new-images/pte/pte5.jpeg" alt="LA" />
                </div>
                {/* <div className="img-wrapper">
                  <img src="/images/web-new-images/pte/pte6.jpeg" alt="LA" />
                </div>
                <div className="img-wrapper">
                  <img src="/images/web-new-images/pte/pte7.jpeg" alt="LA" />
                </div> */}
                <div className="img-wrapper">
                  <img src="/images/web-new-images/pte/pte8.jpeg" alt="LA" />
                </div>
                <div className="img-wrapper">
                  <img src="/images/web-new-images/pte/pte9.jpeg" alt="LA" />
                </div>
                <div className="img-wrapper">
                  <img src="/images/web-new-images/pte/pte10.jpeg" alt="LA" />
                </div>
                <div className="img-wrapper">
                  <img src="/images/web-new-images/pte/pte11.jpeg" alt="LA" />
                </div>
                <div className="img-wrapper">
                  <img src="/images/web-new-images/pte/pte12.jpeg" alt="LA" />
                </div>
            </Slider>
          </div>
          <div className="d-flex justify-content-center">
            <Link className="primary-btn" to="/scorecard">
              <span className="btn-inner">
                VISIT OUR WALL OF FAME{" "}
                <img
                  src="/images/web-new-images/right-arrow.svg"
                  alt="Register Now"
                />
              </span>
            </Link>
          </div>
        </div>
      </div>     
    );
  }
}
export default FameWallPte;
